import HttpClientToken from '../../services/HttpClientToken';

import { defaultTipoOperacionFirma, TipoOperacionFirmaProps } from '../../interfaces/catalogos/TipoOperacionFirmaInterface';

export const TipoOperacionFirmas = () => {

    return new Promise<TipoOperacionFirmaProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoOperacionFirma/', token)
            .then( ({ data } : { data : TipoOperacionFirmaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerTipoOperacionFirma = () => {

    return new Promise<TipoOperacionFirmaProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoOperacionFirma/ObtenerTipoOperacionFirmas', token)
            .then( ({ data } : { data : TipoOperacionFirmaProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarTipoOperacionFirma = ( params: TipoOperacionFirmaProps ) => {

    return new Promise<TipoOperacionFirmaProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoOperacionFirma/Actualizar', params, token)
            .then( ({ data } : { data : TipoOperacionFirmaProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoOperacionFirma } );
            });

        }

    });

}

export const AgregarTipoOperacionFirma = ( params: TipoOperacionFirmaProps ) => {

    return new Promise<TipoOperacionFirmaProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoOperacionFirma/Agregar', params, token)
            .then( ({ data } : { data : TipoOperacionFirmaProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoOperacionFirma } );
            });

        }

    });

}
